import React, { useState, useEffect } from 'react';
// api client
import apiClient from '../app/apiClient.js'
import { useDispatch, useSelector } from 'react-redux'

import { usersApi, selectUsers, setUsers, updateUser } from '../app/users.js'
import { rolesApi } from '../app/roles.js'
import { selectCanAccess, selectCurrentUserId } from '../app/auth.js'
import { Navigate } from 'react-router-dom';
import { projectsApi, selectProjects, setProjects } from '../app/projects.js';

const OUTPUTFIELDS = {
  users: `id,name,email,role`,
  projects: `id, name, adminIds`
}

function UsersPage() {
  const dispatch = useDispatch()
  const users = useSelector(selectUsers)
  const canAccess = useSelector(selectCanAccess)
  const [roles,setRoles] = useState([])
  const userId = useSelector(selectCurrentUserId)
  const projects = useSelector(selectProjects)

  useEffect(() => {
    projectsApi.index({userId},OUTPUTFIELDS.projects,(projects) => {
      dispatch(setProjects(projects))
    })
    usersApi.index({projectId: null}, OUTPUTFIELDS.users, (users) => {
      dispatch(setUsers({users}))
    })
    rolesApi.index((roles) => {
      setRoles(roles)
    })
  }, [])

  const handleUserChange = (id, payload) => {
    usersApi.update({id, ...payload}, OUTPUTFIELDS.users, (user) => {
      dispatch(updateUser({user}))
    })
  }
  
  const handleProjectSelection = (id, projectId) => {
    if (projectId != "") {
      projectsApi.addAdminInProject({userId: id, projectId: projectId}, OUTPUTFIELDS.users, (result) => {
        console.log(result)
      });
    }
  }

  const handleRemoveFromProject = (id, projectId) => {
    if (projectId != "") {
      projectsApi.removeAdminInProject({userId: id, projectId: projectId}, OUTPUTFIELDS.users, (result) => {
        console.log(result)
      });
    }
  }

  const handleRoleChange = (id, newRole) => {
    if (newRole && newRole !== "") {
      handleUserChange(id, { role: newRole });
    }
  }

  // page only for admins
  if (!canAccess('UserPage')) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={{ color: "white", padding: "20px" }}>
      <h1>Users</h1>
      <div>
        <table style={{ width: "100%"}}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Add as project Admin</th>
          </tr>
        </thead>
        <tbody>
          {users.map(({ id, name, email, role }) => (
            <tr key={id} id={id}>
              <td style={{ verticalAlign: "top", paddingTop: "10px" }}>{name || "Null"}</td>
              <td style={{ verticalAlign: "top", paddingTop: "10px" }}>{email}</td>
              <td style={{ verticalAlign: "top", paddingTop: "10px" }}>
                <select
                  onChange={(e) => handleRoleChange(id, e.target.value)}
                  value={role}
                  style={{ minWidth: "120px" }}
                >
                  {/* Show current role if it's not in the standard list */}
                  {!["no_access", "user", "global_reader"].includes(role) && (
                    <option value={role}>{role} (current)</option>
                  )}
                  <option value="no_access">No Access</option>
                  <option value="user">User</option>
                  <option value="global_reader">Global Reader</option>
                </select>
              </td>
              <td style={{ verticalAlign: "top", paddingTop: "10px" }}>
                {/* Add as admin for a project */}
                <select
                  onChange={(e) => handleProjectSelection(id, e.target.value)}
                  value=""
                  style={{ marginBottom: "5px" }}
                >
                  <option value="">Select a project</option>
                  {projects.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>
                <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                  {projects
                    .filter((p) => p.adminIds.includes(id))
                    .map((proj) => (
                      <li key={proj.id} style={{ display: "flex", alignItems: "center" }}>
                        {proj.name}{" "}
                        <button
                          onClick={() => handleRemoveFromProject(id, proj.id)}
                          style={{
                            marginLeft: "5px",
                            background: "none",
                            border: "none",
                            color: "red",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        >
                          ❌
                        </button>
                      </li>
                    ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>
    </div>
  );
  }

export default UsersPage
